import lang from '@/lang/speed-test';

export default ({ store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en, 'speed-test');
  const title = store.$i18n.t('title');
  const description = store.$i18n.t('description');
  store.commit('pageContent/setHead', { title, description });
};
